import type { TicketTaxonomy } from '../../hooks/useTicketingProviders';

/** Type and labels that are saved or selected but missing from the tracker's current taxonomy. */
export function findMissingTaxonomyValues(
  taxonomy: TicketTaxonomy | undefined,
  type: string | null,
  labels: string[]
): { type: string | null; labels: string[] } {
  if (!taxonomy) return { type: null, labels: [] };
  const knownTypes = taxonomy.types?.map((entry) => entry.name);
  const knownLabels = taxonomy.labels?.map((entry) => entry.name);
  return {
    type: type && knownTypes && !knownTypes.includes(type) ? type : null,
    labels: knownLabels ? labels.filter((label) => !knownLabels.includes(label)) : [],
  };
}

/** `type "X" and labels "a", "b"` for whatever of them is present; empty when neither is. */
export function describeMissingTaxonomy(type: string | null, labels: string[]): string {
  return [
    type ? `type "${type}"` : null,
    labels.length > 0 ? `labels ${labels.map((label) => `"${label}"`).join(', ')}` : null,
  ]
    .filter(Boolean)
    .join(' and ');
}
